var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.siteId != null)?_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"10","offset-lg":"1"}},[_c('design-form',{attrs:{"site-id":_vm.siteId}})],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }